!function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("Flowbite", [], e) : "object" == typeof exports ? exports.Flowbite = e() : t.Flowbite = e();
}(self, function() {
    return function() {
        "use strict";
        var t = {
            647: function(t, e, i) {
                i.r(e);
            },
            853: function(t, e, i) {
                i.r(e), i.d(e, {
                    afterMain: function() {
                        return w;
                    },
                    afterRead: function() {
                        return y;
                    },
                    afterWrite: function() {
                        return O;
                    },
                    applyStyles: function() {
                        return P;
                    },
                    arrow: function() {
                        return Q;
                    },
                    auto: function() {
                        return a;
                    },
                    basePlacements: function() {
                        return c;
                    },
                    beforeMain: function() {
                        return b;
                    },
                    beforeRead: function() {
                        return _;
                    },
                    beforeWrite: function() {
                        return L;
                    },
                    bottom: function() {
                        return o;
                    },
                    clippingParents: function() {
                        return u;
                    },
                    computeStyles: function() {
                        return it;
                    },
                    createPopper: function() {
                        return Pt;
                    },
                    createPopperBase: function() {
                        return Ht;
                    },
                    createPopperLite: function() {
                        return St;
                    },
                    detectOverflow: function() {
                        return mt;
                    },
                    end: function() {
                        return l;
                    },
                    eventListeners: function() {
                        return ot;
                    },
                    flip: function() {
                        return yt;
                    },
                    hide: function() {
                        return wt;
                    },
                    left: function() {
                        return s;
                    },
                    main: function() {
                        return E;
                    },
                    modifierPhases: function() {
                        return k;
                    },
                    offset: function() {
                        return Lt;
                    },
                    placements: function() {
                        return g;
                    },
                    popper: function() {
                        return h;
                    },
                    popperGenerator: function() {
                        return Tt;
                    },
                    popperOffsets: function() {
                        return It;
                    },
                    preventOverflow: function() {
                        return Ot;
                    },
                    read: function() {
                        return m;
                    },
                    reference: function() {
                        return f;
                    },
                    right: function() {
                        return r;
                    },
                    start: function() {
                        return d;
                    },
                    top: function() {
                        return n;
                    },
                    variationPlacements: function() {
                        return v;
                    },
                    viewport: function() {
                        return p;
                    },
                    write: function() {
                        return I;
                    }
                });
                var n = "top", o = "bottom", r = "right", s = "left", a = "auto", c = [
                    n,
                    o,
                    r,
                    s
                ], d = "start", l = "end", u = "clippingParents", p = "viewport", h = "popper", f = "reference", v = c.reduce(function(t, e) {
                    return t.concat([
                        e + "-" + d,
                        e + "-" + l
                    ]);
                }, []), g = [].concat(c, [
                    a
                ]).reduce(function(t, e) {
                    return t.concat([
                        e,
                        e + "-" + d,
                        e + "-" + l
                    ]);
                }, []), _ = "beforeRead", m = "read", y = "afterRead", b = "beforeMain", E = "main", w = "afterMain", L = "beforeWrite", I = "write", O = "afterWrite", k = [
                    _,
                    m,
                    y,
                    b,
                    E,
                    w,
                    L,
                    I,
                    O
                ];
                function x(t) {
                    return t ? (t.nodeName || "").toLowerCase() : null;
                }
                function A(t) {
                    if (null == t) return window;
                    if ("[object Window]" !== t.toString()) {
                        var e = t.ownerDocument;
                        return e && e.defaultView || window;
                    }
                    return t;
                }
                function C(t) {
                    return t instanceof A(t).Element || t instanceof Element;
                }
                function T(t) {
                    return t instanceof A(t).HTMLElement || t instanceof HTMLElement;
                }
                function H(t) {
                    return "undefined" != typeof ShadowRoot && (t instanceof A(t).ShadowRoot || t instanceof ShadowRoot);
                }
                var P = {
                    name: "applyStyles",
                    enabled: !0,
                    phase: "write",
                    fn: function(t) {
                        var e = t.state;
                        Object.keys(e.elements).forEach(function(t) {
                            var i = e.styles[t] || {}, n = e.attributes[t] || {}, o = e.elements[t];
                            T(o) && x(o) && (Object.assign(o.style, i), Object.keys(n).forEach(function(t) {
                                var e = n[t];
                                !1 === e ? o.removeAttribute(t) : o.setAttribute(t, !0 === e ? "" : e);
                            }));
                        });
                    },
                    effect: function(t) {
                        var e = t.state, i = {
                            popper: {
                                position: e.options.strategy,
                                left: "0",
                                top: "0",
                                margin: "0"
                            },
                            arrow: {
                                position: "absolute"
                            },
                            reference: {}
                        };
                        return Object.assign(e.elements.popper.style, i.popper), e.styles = i, e.elements.arrow && Object.assign(e.elements.arrow.style, i.arrow), function() {
                            Object.keys(e.elements).forEach(function(t) {
                                var n = e.elements[t], o = e.attributes[t] || {}, r = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : i[t]).reduce(function(t, e) {
                                    return t[e] = "", t;
                                }, {});
                                T(n) && x(n) && (Object.assign(n.style, r), Object.keys(o).forEach(function(t) {
                                    n.removeAttribute(t);
                                }));
                            });
                        };
                    },
                    requires: [
                        "computeStyles"
                    ]
                };
                function S(t) {
                    return t.split("-")[0];
                }
                var j = Math.max, D = Math.min, z = Math.round;
                function M() {
                    var t = navigator.userAgentData;
                    return null != t && t.brands ? t.brands.map(function(t) {
                        return t.brand + "/" + t.version;
                    }).join(" ") : navigator.userAgent;
                }
                function q() {
                    return !/^((?!chrome|android).)*safari/i.test(M());
                }
                function V(t, e, i) {
                    void 0 === e && (e = !1), void 0 === i && (i = !1);
                    var n = t.getBoundingClientRect(), o = 1, r = 1;
                    e && T(t) && (o = t.offsetWidth > 0 && z(n.width) / t.offsetWidth || 1, r = t.offsetHeight > 0 && z(n.height) / t.offsetHeight || 1);
                    var s = (C(t) ? A(t) : window).visualViewport, a = !q() && i, c = (n.left + (a && s ? s.offsetLeft : 0)) / o, d = (n.top + (a && s ? s.offsetTop : 0)) / r, l = n.width / o, u = n.height / r;
                    return {
                        width: l,
                        height: u,
                        top: d,
                        right: c + l,
                        bottom: d + u,
                        left: c,
                        x: c,
                        y: d
                    };
                }
                function B(t) {
                    var e = V(t), i = t.offsetWidth, n = t.offsetHeight;
                    return Math.abs(e.width - i) <= 1 && (i = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
                        x: t.offsetLeft,
                        y: t.offsetTop,
                        width: i,
                        height: n
                    };
                }
                function R(t, e) {
                    var i = e.getRootNode && e.getRootNode();
                    if (t.contains(e)) return !0;
                    if (i && H(i)) {
                        var n = e;
                        do {
                            if (n && t.isSameNode(n)) return !0;
                            n = n.parentNode || n.host;
                        }while (n);
                    }
                    return !1;
                }
                function W(t) {
                    return A(t).getComputedStyle(t);
                }
                function F(t) {
                    return [
                        "table",
                        "td",
                        "th"
                    ].indexOf(x(t)) >= 0;
                }
                function K(t) {
                    return ((C(t) ? t.ownerDocument : t.document) || window.document).documentElement;
                }
                function N(t) {
                    return "html" === x(t) ? t : t.assignedSlot || t.parentNode || (H(t) ? t.host : null) || K(t);
                }
                function U(t) {
                    return T(t) && "fixed" !== W(t).position ? t.offsetParent : null;
                }
                function X(t) {
                    for(var e = A(t), i = U(t); i && F(i) && "static" === W(i).position;)i = U(i);
                    return i && ("html" === x(i) || "body" === x(i) && "static" === W(i).position) ? e : i || function(t) {
                        var e = /firefox/i.test(M());
                        if (/Trident/i.test(M()) && T(t) && "fixed" === W(t).position) return null;
                        var i = N(t);
                        for(H(i) && (i = i.host); T(i) && [
                            "html",
                            "body"
                        ].indexOf(x(i)) < 0;){
                            var n = W(i);
                            if ("none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || -1 !== [
                                "transform",
                                "perspective"
                            ].indexOf(n.willChange) || e && "filter" === n.willChange || e && n.filter && "none" !== n.filter) return i;
                            i = i.parentNode;
                        }
                        return null;
                    }(t) || e;
                }
                function Y(t) {
                    return [
                        "top",
                        "bottom"
                    ].indexOf(t) >= 0 ? "x" : "y";
                }
                function G(t, e, i) {
                    return j(t, D(e, i));
                }
                function $(t) {
                    return Object.assign({}, {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }, t);
                }
                function J(t, e) {
                    return e.reduce(function(e, i) {
                        return e[i] = t, e;
                    }, {});
                }
                var Q = {
                    name: "arrow",
                    enabled: !0,
                    phase: "main",
                    fn: function(t) {
                        var e, i = t.state, a = t.name, d = t.options, l = i.elements.arrow, u = i.modifiersData.popperOffsets, p = S(i.placement), h = Y(p), f = [
                            s,
                            r
                        ].indexOf(p) >= 0 ? "height" : "width";
                        if (l && u) {
                            var v = function(t, e) {
                                return $("number" != typeof (t = "function" == typeof t ? t(Object.assign({}, e.rects, {
                                    placement: e.placement
                                })) : t) ? t : J(t, c));
                            }(d.padding, i), g = B(l), _ = "y" === h ? n : s, m = "y" === h ? o : r, y = i.rects.reference[f] + i.rects.reference[h] - u[h] - i.rects.popper[f], b = u[h] - i.rects.reference[h], E = X(l), w = E ? "y" === h ? E.clientHeight || 0 : E.clientWidth || 0 : 0, L = y / 2 - b / 2, I = v[_], O = w - g[f] - v[m], k = w / 2 - g[f] / 2 + L, x = G(I, k, O), A = h;
                            i.modifiersData[a] = ((e = {})[A] = x, e.centerOffset = x - k, e);
                        }
                    },
                    effect: function(t) {
                        var e = t.state, i = t.options.element, n = void 0 === i ? "[data-popper-arrow]" : i;
                        null != n && ("string" != typeof n || (n = e.elements.popper.querySelector(n))) && R(e.elements.popper, n) && (e.elements.arrow = n);
                    },
                    requires: [
                        "popperOffsets"
                    ],
                    requiresIfExists: [
                        "preventOverflow"
                    ]
                };
                function Z(t) {
                    return t.split("-")[1];
                }
                var tt = {
                    top: "auto",
                    right: "auto",
                    bottom: "auto",
                    left: "auto"
                };
                function et(t) {
                    var e, i = t.popper, a = t.popperRect, c = t.placement, d = t.variation, u = t.offsets, p = t.position, h = t.gpuAcceleration, f = t.adaptive, v = t.roundOffsets, g = t.isFixed, _ = u.x, m = void 0 === _ ? 0 : _, y = u.y, b = void 0 === y ? 0 : y, E = "function" == typeof v ? v({
                        x: m,
                        y: b
                    }) : {
                        x: m,
                        y: b
                    };
                    m = E.x, b = E.y;
                    var w = u.hasOwnProperty("x"), L = u.hasOwnProperty("y"), I = s, O = n, k = window;
                    if (f) {
                        var x = X(i), C = "clientHeight", T = "clientWidth";
                        if (x === A(i) && "static" !== W(x = K(i)).position && "absolute" === p && (C = "scrollHeight", T = "scrollWidth"), c === n || (c === s || c === r) && d === l) O = o, b -= (g && x === k && k.visualViewport ? k.visualViewport.height : x[C]) - a.height, b *= h ? 1 : -1;
                        if (c === s || (c === n || c === o) && d === l) I = r, m -= (g && x === k && k.visualViewport ? k.visualViewport.width : x[T]) - a.width, m *= h ? 1 : -1;
                    }
                    var H, P = Object.assign({
                        position: p
                    }, f && tt), S = !0 === v ? function(t) {
                        var e = t.x, i = t.y, n = window.devicePixelRatio || 1;
                        return {
                            x: z(e * n) / n || 0,
                            y: z(i * n) / n || 0
                        };
                    }({
                        x: m,
                        y: b
                    }) : {
                        x: m,
                        y: b
                    };
                    return m = S.x, b = S.y, h ? Object.assign({}, P, ((H = {})[O] = L ? "0" : "", H[I] = w ? "0" : "", H.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + b + "px)" : "translate3d(" + m + "px, " + b + "px, 0)", H)) : Object.assign({}, P, ((e = {})[O] = L ? b + "px" : "", e[I] = w ? m + "px" : "", e.transform = "", e));
                }
                var it = {
                    name: "computeStyles",
                    enabled: !0,
                    phase: "beforeWrite",
                    fn: function(t) {
                        var e = t.state, i = t.options, n = i.gpuAcceleration, o = void 0 === n || n, r = i.adaptive, s = void 0 === r || r, a = i.roundOffsets, c = void 0 === a || a, d = {
                            placement: S(e.placement),
                            variation: Z(e.placement),
                            popper: e.elements.popper,
                            popperRect: e.rects.popper,
                            gpuAcceleration: o,
                            isFixed: "fixed" === e.options.strategy
                        };
                        null != e.modifiersData.popperOffsets && (e.styles.popper = Object.assign({}, e.styles.popper, et(Object.assign({}, d, {
                            offsets: e.modifiersData.popperOffsets,
                            position: e.options.strategy,
                            adaptive: s,
                            roundOffsets: c
                        })))), null != e.modifiersData.arrow && (e.styles.arrow = Object.assign({}, e.styles.arrow, et(Object.assign({}, d, {
                            offsets: e.modifiersData.arrow,
                            position: "absolute",
                            adaptive: !1,
                            roundOffsets: c
                        })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
                            "data-popper-placement": e.placement
                        });
                    },
                    data: {}
                }, nt = {
                    passive: !0
                };
                var ot = {
                    name: "eventListeners",
                    enabled: !0,
                    phase: "write",
                    fn: function() {},
                    effect: function(t) {
                        var e = t.state, i = t.instance, n = t.options, o = n.scroll, r = void 0 === o || o, s = n.resize, a = void 0 === s || s, c = A(e.elements.popper), d = [].concat(e.scrollParents.reference, e.scrollParents.popper);
                        return r && d.forEach(function(t) {
                            t.addEventListener("scroll", i.update, nt);
                        }), a && c.addEventListener("resize", i.update, nt), function() {
                            r && d.forEach(function(t) {
                                t.removeEventListener("scroll", i.update, nt);
                            }), a && c.removeEventListener("resize", i.update, nt);
                        };
                    },
                    data: {}
                }, rt = {
                    left: "right",
                    right: "left",
                    bottom: "top",
                    top: "bottom"
                };
                function st(t) {
                    return t.replace(/left|right|bottom|top/g, function(t) {
                        return rt[t];
                    });
                }
                var at = {
                    start: "end",
                    end: "start"
                };
                function ct(t) {
                    return t.replace(/start|end/g, function(t) {
                        return at[t];
                    });
                }
                function dt(t) {
                    var e = A(t);
                    return {
                        scrollLeft: e.pageXOffset,
                        scrollTop: e.pageYOffset
                    };
                }
                function lt(t) {
                    return V(K(t)).left + dt(t).scrollLeft;
                }
                function ut(t) {
                    var e = W(t), i = e.overflow, n = e.overflowX, o = e.overflowY;
                    return /auto|scroll|overlay|hidden/.test(i + o + n);
                }
                function pt(t) {
                    return [
                        "html",
                        "body",
                        "#document"
                    ].indexOf(x(t)) >= 0 ? t.ownerDocument.body : T(t) && ut(t) ? t : pt(N(t));
                }
                function ht(t, e) {
                    var i;
                    void 0 === e && (e = []);
                    var n = pt(t), o = n === (null == (i = t.ownerDocument) ? void 0 : i.body), r = A(n), s = o ? [
                        r
                    ].concat(r.visualViewport || [], ut(n) ? n : []) : n, a = e.concat(s);
                    return o ? a : a.concat(ht(N(s)));
                }
                function ft(t) {
                    return Object.assign({}, t, {
                        left: t.x,
                        top: t.y,
                        right: t.x + t.width,
                        bottom: t.y + t.height
                    });
                }
                function vt(t, e, i) {
                    return e === p ? ft(function(t, e) {
                        var i = A(t), n = K(t), o = i.visualViewport, r = n.clientWidth, s = n.clientHeight, a = 0, c = 0;
                        if (o) {
                            r = o.width, s = o.height;
                            var d = q();
                            (d || !d && "fixed" === e) && (a = o.offsetLeft, c = o.offsetTop);
                        }
                        return {
                            width: r,
                            height: s,
                            x: a + lt(t),
                            y: c
                        };
                    }(t, i)) : C(e) ? function(t, e) {
                        var i = V(t, !1, "fixed" === e);
                        return i.top = i.top + t.clientTop, i.left = i.left + t.clientLeft, i.bottom = i.top + t.clientHeight, i.right = i.left + t.clientWidth, i.width = t.clientWidth, i.height = t.clientHeight, i.x = i.left, i.y = i.top, i;
                    }(e, i) : ft(function(t) {
                        var e, i = K(t), n = dt(t), o = null == (e = t.ownerDocument) ? void 0 : e.body, r = j(i.scrollWidth, i.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = j(i.scrollHeight, i.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -n.scrollLeft + lt(t), c = -n.scrollTop;
                        return "rtl" === W(o || i).direction && (a += j(i.clientWidth, o ? o.clientWidth : 0) - r), {
                            width: r,
                            height: s,
                            x: a,
                            y: c
                        };
                    }(K(t)));
                }
                function gt(t, e, i, n) {
                    var o = "clippingParents" === e ? function(t) {
                        var e = ht(N(t)), i = [
                            "absolute",
                            "fixed"
                        ].indexOf(W(t).position) >= 0 && T(t) ? X(t) : t;
                        return C(i) ? e.filter(function(t) {
                            return C(t) && R(t, i) && "body" !== x(t);
                        }) : [];
                    }(t) : [].concat(e), r = [].concat(o, [
                        i
                    ]), s = r[0], a = r.reduce(function(e, i) {
                        var o = vt(t, i, n);
                        return e.top = j(o.top, e.top), e.right = D(o.right, e.right), e.bottom = D(o.bottom, e.bottom), e.left = j(o.left, e.left), e;
                    }, vt(t, s, n));
                    return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
                }
                function _t(t) {
                    var e, i = t.reference, a = t.element, c = t.placement, u = c ? S(c) : null, p = c ? Z(c) : null, h = i.x + i.width / 2 - a.width / 2, f = i.y + i.height / 2 - a.height / 2;
                    switch(u){
                        case n:
                            e = {
                                x: h,
                                y: i.y - a.height
                            };
                            break;
                        case o:
                            e = {
                                x: h,
                                y: i.y + i.height
                            };
                            break;
                        case r:
                            e = {
                                x: i.x + i.width,
                                y: f
                            };
                            break;
                        case s:
                            e = {
                                x: i.x - a.width,
                                y: f
                            };
                            break;
                        default:
                            e = {
                                x: i.x,
                                y: i.y
                            };
                    }
                    var v = u ? Y(u) : null;
                    if (null != v) {
                        var g = "y" === v ? "height" : "width";
                        switch(p){
                            case d:
                                e[v] = e[v] - (i[g] / 2 - a[g] / 2);
                                break;
                            case l:
                                e[v] = e[v] + (i[g] / 2 - a[g] / 2);
                        }
                    }
                    return e;
                }
                function mt(t, e) {
                    void 0 === e && (e = {});
                    var i = e, s = i.placement, a = void 0 === s ? t.placement : s, d = i.strategy, l = void 0 === d ? t.strategy : d, v = i.boundary, g = void 0 === v ? u : v, _ = i.rootBoundary, m = void 0 === _ ? p : _, y = i.elementContext, b = void 0 === y ? h : y, E = i.altBoundary, w = void 0 !== E && E, L = i.padding, I = void 0 === L ? 0 : L, O = $("number" != typeof I ? I : J(I, c)), k = b === h ? f : h, x = t.rects.popper, A = t.elements[w ? k : b], T = gt(C(A) ? A : A.contextElement || K(t.elements.popper), g, m, l), H = V(t.elements.reference), P = _t({
                        reference: H,
                        element: x,
                        strategy: "absolute",
                        placement: a
                    }), S = ft(Object.assign({}, x, P)), j = b === h ? S : H, D = {
                        top: T.top - j.top + O.top,
                        bottom: j.bottom - T.bottom + O.bottom,
                        left: T.left - j.left + O.left,
                        right: j.right - T.right + O.right
                    }, z = t.modifiersData.offset;
                    if (b === h && z) {
                        var M = z[a];
                        Object.keys(D).forEach(function(t) {
                            var e = [
                                r,
                                o
                            ].indexOf(t) >= 0 ? 1 : -1, i = [
                                n,
                                o
                            ].indexOf(t) >= 0 ? "y" : "x";
                            D[t] += M[i] * e;
                        });
                    }
                    return D;
                }
                var yt = {
                    name: "flip",
                    enabled: !0,
                    phase: "main",
                    fn: function(t) {
                        var e = t.state, i = t.options, l = t.name;
                        if (!e.modifiersData[l]._skip) {
                            for(var u = i.mainAxis, p = void 0 === u || u, h = i.altAxis, f = void 0 === h || h, _ = i.fallbackPlacements, m = i.padding, y = i.boundary, b = i.rootBoundary, E = i.altBoundary, w = i.flipVariations, L = void 0 === w || w, I = i.allowedAutoPlacements, O = e.options.placement, k = S(O), x = _ || (k === O || !L ? [
                                st(O)
                            ] : function(t) {
                                if (S(t) === a) return [];
                                var e = st(t);
                                return [
                                    ct(t),
                                    e,
                                    ct(e)
                                ];
                            }(O)), A = [
                                O
                            ].concat(x).reduce(function(t, i) {
                                return t.concat(S(i) === a ? function(t, e) {
                                    void 0 === e && (e = {});
                                    var i = e, n = i.placement, o = i.boundary, r = i.rootBoundary, s = i.padding, a = i.flipVariations, d = i.allowedAutoPlacements, l = void 0 === d ? g : d, u = Z(n), p = u ? a ? v : v.filter(function(t) {
                                        return Z(t) === u;
                                    }) : c, h = p.filter(function(t) {
                                        return l.indexOf(t) >= 0;
                                    });
                                    0 === h.length && (h = p);
                                    var f = h.reduce(function(e, i) {
                                        return e[i] = mt(t, {
                                            placement: i,
                                            boundary: o,
                                            rootBoundary: r,
                                            padding: s
                                        })[S(i)], e;
                                    }, {});
                                    return Object.keys(f).sort(function(t, e) {
                                        return f[t] - f[e];
                                    });
                                }(e, {
                                    placement: i,
                                    boundary: y,
                                    rootBoundary: b,
                                    padding: m,
                                    flipVariations: L,
                                    allowedAutoPlacements: I
                                }) : i);
                            }, []), C = e.rects.reference, T = e.rects.popper, H = new Map, P = !0, j = A[0], D = 0; D < A.length; D++){
                                var z = A[D], M = S(z), q = Z(z) === d, V = [
                                    n,
                                    o
                                ].indexOf(M) >= 0, B = V ? "width" : "height", R = mt(e, {
                                    placement: z,
                                    boundary: y,
                                    rootBoundary: b,
                                    altBoundary: E,
                                    padding: m
                                }), W = V ? q ? r : s : q ? o : n;
                                C[B] > T[B] && (W = st(W));
                                var F = st(W), K = [];
                                if (p && K.push(R[M] <= 0), f && K.push(R[W] <= 0, R[F] <= 0), K.every(function(t) {
                                    return t;
                                })) {
                                    j = z, P = !1;
                                    break;
                                }
                                H.set(z, K);
                            }
                            if (P) for(var N = function(t) {
                                var e = A.find(function(e) {
                                    var i = H.get(e);
                                    if (i) return i.slice(0, t).every(function(t) {
                                        return t;
                                    });
                                });
                                if (e) return j = e, "break";
                            }, U = L ? 3 : 1; U > 0; U--){
                                if ("break" === N(U)) break;
                            }
                            e.placement !== j && (e.modifiersData[l]._skip = !0, e.placement = j, e.reset = !0);
                        }
                    },
                    requiresIfExists: [
                        "offset"
                    ],
                    data: {
                        _skip: !1
                    }
                };
                function bt(t, e, i) {
                    return void 0 === i && (i = {
                        x: 0,
                        y: 0
                    }), {
                        top: t.top - e.height - i.y,
                        right: t.right - e.width + i.x,
                        bottom: t.bottom - e.height + i.y,
                        left: t.left - e.width - i.x
                    };
                }
                function Et(t) {
                    return [
                        n,
                        r,
                        o,
                        s
                    ].some(function(e) {
                        return t[e] >= 0;
                    });
                }
                var wt = {
                    name: "hide",
                    enabled: !0,
                    phase: "main",
                    requiresIfExists: [
                        "preventOverflow"
                    ],
                    fn: function(t) {
                        var e = t.state, i = t.name, n = e.rects.reference, o = e.rects.popper, r = e.modifiersData.preventOverflow, s = mt(e, {
                            elementContext: "reference"
                        }), a = mt(e, {
                            altBoundary: !0
                        }), c = bt(s, n), d = bt(a, o, r), l = Et(c), u = Et(d);
                        e.modifiersData[i] = {
                            referenceClippingOffsets: c,
                            popperEscapeOffsets: d,
                            isReferenceHidden: l,
                            hasPopperEscaped: u
                        }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
                            "data-popper-reference-hidden": l,
                            "data-popper-escaped": u
                        });
                    }
                };
                var Lt = {
                    name: "offset",
                    enabled: !0,
                    phase: "main",
                    requires: [
                        "popperOffsets"
                    ],
                    fn: function(t) {
                        var e = t.state, i = t.options, o = t.name, a = i.offset, c = void 0 === a ? [
                            0,
                            0
                        ] : a, d = g.reduce(function(t, i) {
                            return t[i] = function(t, e, i) {
                                var o = S(t), a = [
                                    s,
                                    n
                                ].indexOf(o) >= 0 ? -1 : 1, c = "function" == typeof i ? i(Object.assign({}, e, {
                                    placement: t
                                })) : i, d = c[0], l = c[1];
                                return d = d || 0, l = (l || 0) * a, [
                                    s,
                                    r
                                ].indexOf(o) >= 0 ? {
                                    x: l,
                                    y: d
                                } : {
                                    x: d,
                                    y: l
                                };
                            }(i, e.rects, c), t;
                        }, {}), l = d[e.placement], u = l.x, p = l.y;
                        null != e.modifiersData.popperOffsets && (e.modifiersData.popperOffsets.x += u, e.modifiersData.popperOffsets.y += p), e.modifiersData[o] = d;
                    }
                };
                var It = {
                    name: "popperOffsets",
                    enabled: !0,
                    phase: "read",
                    fn: function(t) {
                        var e = t.state, i = t.name;
                        e.modifiersData[i] = _t({
                            reference: e.rects.reference,
                            element: e.rects.popper,
                            strategy: "absolute",
                            placement: e.placement
                        });
                    },
                    data: {}
                };
                var Ot = {
                    name: "preventOverflow",
                    enabled: !0,
                    phase: "main",
                    fn: function(t) {
                        var e = t.state, i = t.options, a = t.name, c = i.mainAxis, l = void 0 === c || c, u = i.altAxis, p = void 0 !== u && u, h = i.boundary, f = i.rootBoundary, v = i.altBoundary, g = i.padding, _ = i.tether, m = void 0 === _ || _, y = i.tetherOffset, b = void 0 === y ? 0 : y, E = mt(e, {
                            boundary: h,
                            rootBoundary: f,
                            padding: g,
                            altBoundary: v
                        }), w = S(e.placement), L = Z(e.placement), I = !L, O = Y(w), k = "x" === O ? "y" : "x", x = e.modifiersData.popperOffsets, A = e.rects.reference, C = e.rects.popper, T = "function" == typeof b ? b(Object.assign({}, e.rects, {
                            placement: e.placement
                        })) : b, H = "number" == typeof T ? {
                            mainAxis: T,
                            altAxis: T
                        } : Object.assign({
                            mainAxis: 0,
                            altAxis: 0
                        }, T), P = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, z = {
                            x: 0,
                            y: 0
                        };
                        if (x) {
                            if (l) {
                                var M, q = "y" === O ? n : s, V = "y" === O ? o : r, R = "y" === O ? "height" : "width", W = x[O], F = W + E[q], K = W - E[V], N = m ? -C[R] / 2 : 0, U = L === d ? A[R] : C[R], $ = L === d ? -C[R] : -A[R], J = e.elements.arrow, Q = m && J ? B(J) : {
                                    width: 0,
                                    height: 0
                                }, tt = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                }, et = tt[q], it = tt[V], nt = G(0, A[R], Q[R]), ot = I ? A[R] / 2 - N - nt - et - H.mainAxis : U - nt - et - H.mainAxis, rt = I ? -A[R] / 2 + N + nt + it + H.mainAxis : $ + nt + it + H.mainAxis, st = e.elements.arrow && X(e.elements.arrow), at = st ? "y" === O ? st.clientTop || 0 : st.clientLeft || 0 : 0, ct = null != (M = null == P ? void 0 : P[O]) ? M : 0, dt = W + rt - ct, lt = G(m ? D(F, W + ot - ct - at) : F, W, m ? j(K, dt) : K);
                                x[O] = lt, z[O] = lt - W;
                            }
                            if (p) {
                                var ut, pt = "x" === O ? n : s, ht = "x" === O ? o : r, ft = x[k], vt = "y" === k ? "height" : "width", gt = ft + E[pt], _t = ft - E[ht], yt = -1 !== [
                                    n,
                                    s
                                ].indexOf(w), bt = null != (ut = null == P ? void 0 : P[k]) ? ut : 0, Et = yt ? gt : ft - A[vt] - C[vt] - bt + H.altAxis, wt = yt ? ft + A[vt] + C[vt] - bt - H.altAxis : _t, Lt = m && yt ? function(t, e, i) {
                                    var n = G(t, e, i);
                                    return n > i ? i : n;
                                }(Et, ft, wt) : G(m ? Et : gt, ft, m ? wt : _t);
                                x[k] = Lt, z[k] = Lt - ft;
                            }
                            e.modifiersData[a] = z;
                        }
                    },
                    requiresIfExists: [
                        "offset"
                    ]
                };
                function kt(t, e, i) {
                    void 0 === i && (i = !1);
                    var n, o, r = T(e), s = T(e) && function(t) {
                        var e = t.getBoundingClientRect(), i = z(e.width) / t.offsetWidth || 1, n = z(e.height) / t.offsetHeight || 1;
                        return 1 !== i || 1 !== n;
                    }(e), a = K(e), c = V(t, s, i), d = {
                        scrollLeft: 0,
                        scrollTop: 0
                    }, l = {
                        x: 0,
                        y: 0
                    };
                    return (r || !r && !i) && (("body" !== x(e) || ut(a)) && (d = (n = e) !== A(n) && T(n) ? {
                        scrollLeft: (o = n).scrollLeft,
                        scrollTop: o.scrollTop
                    } : dt(n)), T(e) ? ((l = V(e, !0)).x += e.clientLeft, l.y += e.clientTop) : a && (l.x = lt(a))), {
                        x: c.left + d.scrollLeft - l.x,
                        y: c.top + d.scrollTop - l.y,
                        width: c.width,
                        height: c.height
                    };
                }
                function xt(t) {
                    var e = new Map, i = new Set, n = [];
                    function o(t) {
                        i.add(t.name), [].concat(t.requires || [], t.requiresIfExists || []).forEach(function(t) {
                            if (!i.has(t)) {
                                var n = e.get(t);
                                n && o(n);
                            }
                        }), n.push(t);
                    }
                    return t.forEach(function(t) {
                        e.set(t.name, t);
                    }), t.forEach(function(t) {
                        i.has(t.name) || o(t);
                    }), n;
                }
                var At = {
                    placement: "bottom",
                    modifiers: [],
                    strategy: "absolute"
                };
                function Ct() {
                    for(var t = arguments.length, e = new Array(t), i = 0; i < t; i++)e[i] = arguments[i];
                    return !e.some(function(t) {
                        return !(t && "function" == typeof t.getBoundingClientRect);
                    });
                }
                function Tt(t) {
                    void 0 === t && (t = {});
                    var e = t, i = e.defaultModifiers, n = void 0 === i ? [] : i, o = e.defaultOptions, r = void 0 === o ? At : o;
                    return function(t, e, i) {
                        void 0 === i && (i = r);
                        var o, s, a = {
                            placement: "bottom",
                            orderedModifiers: [],
                            options: Object.assign({}, At, r),
                            modifiersData: {},
                            elements: {
                                reference: t,
                                popper: e
                            },
                            attributes: {},
                            styles: {}
                        }, c = [], d = !1, l = {
                            state: a,
                            setOptions: function(i) {
                                var o = "function" == typeof i ? i(a.options) : i;
                                u(), a.options = Object.assign({}, r, a.options, o), a.scrollParents = {
                                    reference: C(t) ? ht(t) : t.contextElement ? ht(t.contextElement) : [],
                                    popper: ht(e)
                                };
                                var s = function(t) {
                                    var e = xt(t);
                                    return k.reduce(function(t, i) {
                                        return t.concat(e.filter(function(t) {
                                            return t.phase === i;
                                        }));
                                    }, []);
                                }(function(t) {
                                    var e = t.reduce(function(t, e) {
                                        var i = t[e.name];
                                        return t[e.name] = i ? Object.assign({}, i, e, {
                                            options: Object.assign({}, i.options, e.options),
                                            data: Object.assign({}, i.data, e.data)
                                        }) : e, t;
                                    }, {});
                                    return Object.keys(e).map(function(t) {
                                        return e[t];
                                    });
                                }([].concat(n, a.options.modifiers)));
                                return a.orderedModifiers = s.filter(function(t) {
                                    return t.enabled;
                                }), a.orderedModifiers.forEach(function(t) {
                                    var e = t.name, i = t.options, n = void 0 === i ? {} : i, o = t.effect;
                                    if ("function" == typeof o) {
                                        var r = o({
                                            state: a,
                                            name: e,
                                            instance: l,
                                            options: n
                                        }), s = function() {};
                                        c.push(r || s);
                                    }
                                }), l.update();
                            },
                            forceUpdate: function() {
                                if (!d) {
                                    var t = a.elements, e = t.reference, i = t.popper;
                                    if (Ct(e, i)) {
                                        a.rects = {
                                            reference: kt(e, X(i), "fixed" === a.options.strategy),
                                            popper: B(i)
                                        }, a.reset = !1, a.placement = a.options.placement, a.orderedModifiers.forEach(function(t) {
                                            return a.modifiersData[t.name] = Object.assign({}, t.data);
                                        });
                                        for(var n = 0; n < a.orderedModifiers.length; n++)if (!0 !== a.reset) {
                                            var o = a.orderedModifiers[n], r = o.fn, s = o.options, c = void 0 === s ? {} : s, u = o.name;
                                            "function" == typeof r && (a = r({
                                                state: a,
                                                options: c,
                                                name: u,
                                                instance: l
                                            }) || a);
                                        } else a.reset = !1, n = -1;
                                    }
                                }
                            },
                            update: (o = function() {
                                return new Promise(function(t) {
                                    l.forceUpdate(), t(a);
                                });
                            }, function() {
                                return s || (s = new Promise(function(t) {
                                    Promise.resolve().then(function() {
                                        s = void 0, t(o());
                                    });
                                })), s;
                            }),
                            destroy: function() {
                                u(), d = !0;
                            }
                        };
                        if (!Ct(t, e)) return l;
                        function u() {
                            c.forEach(function(t) {
                                return t();
                            }), c = [];
                        }
                        return l.setOptions(i).then(function(t) {
                            !d && i.onFirstUpdate && i.onFirstUpdate(t);
                        }), l;
                    };
                }
                var Ht = Tt(), Pt = Tt({
                    defaultModifiers: [
                        ot,
                        It,
                        it,
                        P,
                        Lt,
                        yt,
                        Ot,
                        Q,
                        wt
                    ]
                }), St = Tt({
                    defaultModifiers: [
                        ot,
                        It,
                        it,
                        P
                    ]
                });
            },
            902: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initAccordions = void 0;
                var o = i(423), r = {
                    alwaysOpen: !1,
                    activeClasses: "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white",
                    inactiveClasses: "text-gray-500 dark:text-gray-400",
                    onOpen: function() {},
                    onClose: function() {},
                    onToggle: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a) {
                        void 0 === t && (t = null), void 0 === e && (e = []), void 0 === i && (i = r), void 0 === a && (a = s), this._instanceId = a.id ? a.id : t.id, this._accordionEl = t, this._items = e, this._options = n(n({}, r), i), this._initialized = !1, this.init(), o.default.addInstance("Accordion", this, this._instanceId, a.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._items.length && !this._initialized && (this._items.forEach(function(e) {
                            e.active && t.open(e.id);
                            var i = function() {
                                t.toggle(e.id);
                            };
                            e.triggerEl.addEventListener("click", i), e.clickHandler = i;
                        }), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._items.length && this._initialized && (this._items.forEach(function(t) {
                            t.triggerEl.removeEventListener("click", t.clickHandler), delete t.clickHandler;
                        }), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Accordion", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.getItem = function(t) {
                        return this._items.filter(function(e) {
                            return e.id === t;
                        })[0];
                    }, t.prototype.open = function(t) {
                        var e, i, n = this, o = this.getItem(t);
                        this._options.alwaysOpen || this._items.map(function(t) {
                            var e, i;
                            t !== o && ((e = t.triggerEl.classList).remove.apply(e, n._options.activeClasses.split(" ")), (i = t.triggerEl.classList).add.apply(i, n._options.inactiveClasses.split(" ")), t.targetEl.classList.add("hidden"), t.triggerEl.setAttribute("aria-expanded", "false"), t.active = !1, t.iconEl && t.iconEl.classList.add("rotate-180"));
                        }), (e = o.triggerEl.classList).add.apply(e, this._options.activeClasses.split(" ")), (i = o.triggerEl.classList).remove.apply(i, this._options.inactiveClasses.split(" ")), o.triggerEl.setAttribute("aria-expanded", "true"), o.targetEl.classList.remove("hidden"), o.active = !0, o.iconEl && o.iconEl.classList.remove("rotate-180"), this._options.onOpen(this, o);
                    }, t.prototype.toggle = function(t) {
                        var e = this.getItem(t);
                        e.active ? this.close(t) : this.open(t), this._options.onToggle(this, e);
                    }, t.prototype.close = function(t) {
                        var e, i, n = this.getItem(t);
                        (e = n.triggerEl.classList).remove.apply(e, this._options.activeClasses.split(" ")), (i = n.triggerEl.classList).add.apply(i, this._options.inactiveClasses.split(" ")), n.targetEl.classList.add("hidden"), n.triggerEl.setAttribute("aria-expanded", "false"), n.active = !1, n.iconEl && n.iconEl.classList.add("rotate-180"), this._options.onClose(this, n);
                    }, t.prototype.updateOnOpen = function(t) {
                        this._options.onOpen = t;
                    }, t.prototype.updateOnClose = function(t) {
                        this._options.onClose = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-accordion]").forEach(function(t) {
                        var e = t.getAttribute("data-accordion"), i = t.getAttribute("data-active-classes"), n = t.getAttribute("data-inactive-classes"), o = [];
                        t.querySelectorAll("[data-accordion-target]").forEach(function(e) {
                            if (e.closest("[data-accordion]") === t) {
                                var i = {
                                    id: e.getAttribute("data-accordion-target"),
                                    triggerEl: e,
                                    targetEl: document.querySelector(e.getAttribute("data-accordion-target")),
                                    iconEl: e.querySelector("[data-accordion-icon]"),
                                    active: "true" === e.getAttribute("aria-expanded")
                                };
                                o.push(i);
                            }
                        }), new a(t, o, {
                            alwaysOpen: "open" === e,
                            activeClasses: i || r.activeClasses,
                            inactiveClasses: n || r.inactiveClasses
                        });
                    });
                }
                e.initAccordions = c, "undefined" != typeof window && (window.Accordion = a, window.initAccordions = c), e.default = a;
            },
            33: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initCarousels = void 0;
                var o = i(423), r = {
                    defaultPosition: 0,
                    indicators: {
                        items: [],
                        activeClasses: "bg-white dark:bg-gray-800",
                        inactiveClasses: "bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800"
                    },
                    interval: 3e3,
                    onNext: function() {},
                    onPrev: function() {},
                    onChange: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a) {
                        void 0 === t && (t = null), void 0 === e && (e = []), void 0 === i && (i = r), void 0 === a && (a = s), this._instanceId = a.id ? a.id : t.id, this._carouselEl = t, this._items = e, this._options = n(n(n({}, r), i), {
                            indicators: n(n({}, r.indicators), i.indicators)
                        }), this._activeItem = this.getItem(this._options.defaultPosition), this._indicators = this._options.indicators.items, this._intervalDuration = this._options.interval, this._intervalInstance = null, this._initialized = !1, this.init(), o.default.addInstance("Carousel", this, this._instanceId, a.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._items.length && !this._initialized && (this._items.map(function(t) {
                            t.el.classList.add("absolute", "inset-0", "transition-transform", "transform");
                        }), this.getActiveItem() ? this.slideTo(this.getActiveItem().position) : this.slideTo(0), this._indicators.map(function(e, i) {
                            e.el.addEventListener("click", function() {
                                t.slideTo(i);
                            });
                        }), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._initialized && (this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Carousel", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.getItem = function(t) {
                        return this._items[t];
                    }, t.prototype.slideTo = function(t) {
                        var e = this._items[t], i = {
                            left: 0 === e.position ? this._items[this._items.length - 1] : this._items[e.position - 1],
                            middle: e,
                            right: e.position === this._items.length - 1 ? this._items[0] : this._items[e.position + 1]
                        };
                        this._rotate(i), this._setActiveItem(e), this._intervalInstance && (this.pause(), this.cycle()), this._options.onChange(this);
                    }, t.prototype.next = function() {
                        var t = this.getActiveItem(), e = null;
                        e = t.position === this._items.length - 1 ? this._items[0] : this._items[t.position + 1], this.slideTo(e.position), this._options.onNext(this);
                    }, t.prototype.prev = function() {
                        var t = this.getActiveItem(), e = null;
                        e = 0 === t.position ? this._items[this._items.length - 1] : this._items[t.position - 1], this.slideTo(e.position), this._options.onPrev(this);
                    }, t.prototype._rotate = function(t) {
                        if (this._items.map(function(t) {
                            t.el.classList.add("hidden");
                        }), 1 === this._items.length) return t.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10"), void t.middle.el.classList.add("translate-x-0", "z-20");
                        t.left.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-20"), t.left.el.classList.add("-translate-x-full", "z-10"), t.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10"), t.middle.el.classList.add("translate-x-0", "z-30"), t.right.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-30"), t.right.el.classList.add("translate-x-full", "z-20");
                    }, t.prototype.cycle = function() {
                        var t = this;
                        "undefined" != typeof window && (this._intervalInstance = window.setInterval(function() {
                            t.next();
                        }, this._intervalDuration));
                    }, t.prototype.pause = function() {
                        clearInterval(this._intervalInstance);
                    }, t.prototype.getActiveItem = function() {
                        return this._activeItem;
                    }, t.prototype._setActiveItem = function(t) {
                        var e, i, n = this;
                        this._activeItem = t;
                        var o = t.position;
                        this._indicators.length && (this._indicators.map(function(t) {
                            var e, i;
                            t.el.setAttribute("aria-current", "false"), (e = t.el.classList).remove.apply(e, n._options.indicators.activeClasses.split(" ")), (i = t.el.classList).add.apply(i, n._options.indicators.inactiveClasses.split(" "));
                        }), (e = this._indicators[o].el.classList).add.apply(e, this._options.indicators.activeClasses.split(" ")), (i = this._indicators[o].el.classList).remove.apply(i, this._options.indicators.inactiveClasses.split(" ")), this._indicators[o].el.setAttribute("aria-current", "true"));
                    }, t.prototype.updateOnNext = function(t) {
                        this._options.onNext = t;
                    }, t.prototype.updateOnPrev = function(t) {
                        this._options.onPrev = t;
                    }, t.prototype.updateOnChange = function(t) {
                        this._options.onChange = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-carousel]").forEach(function(t) {
                        var e = t.getAttribute("data-carousel-interval"), i = "slide" === t.getAttribute("data-carousel"), n = [], o = 0;
                        t.querySelectorAll("[data-carousel-item]").length && Array.from(t.querySelectorAll("[data-carousel-item]")).map(function(t, e) {
                            n.push({
                                position: e,
                                el: t
                            }), "active" === t.getAttribute("data-carousel-item") && (o = e);
                        });
                        var s = [];
                        t.querySelectorAll("[data-carousel-slide-to]").length && Array.from(t.querySelectorAll("[data-carousel-slide-to]")).map(function(t) {
                            s.push({
                                position: parseInt(t.getAttribute("data-carousel-slide-to")),
                                el: t
                            });
                        });
                        var c = new a(t, n, {
                            defaultPosition: o,
                            indicators: {
                                items: s
                            },
                            interval: e || r.interval
                        });
                        i && c.cycle();
                        var d = t.querySelector("[data-carousel-next]"), l = t.querySelector("[data-carousel-prev]");
                        d && d.addEventListener("click", function() {
                            c.next();
                        }), l && l.addEventListener("click", function() {
                            c.prev();
                        });
                    });
                }
                e.initCarousels = c, "undefined" != typeof window && (window.Carousel = a, window.initCarousels = c), e.default = a;
            },
            673: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initCopyClipboards = void 0;
                var o = i(423), r = {
                    htmlEntities: !1,
                    contentType: "input",
                    onCopy: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = r), void 0 === a && (a = s), this._instanceId = a.id ? a.id : e.id, this._triggerEl = t, this._targetEl = e, this._options = n(n({}, r), i), this._initialized = !1, this.init(), o.default.addInstance("CopyClipboard", this, this._instanceId, a.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._targetEl && this._triggerEl && !this._initialized && (this._triggerElClickHandler = function() {
                            t.copy();
                        }, this._triggerEl && this._triggerEl.addEventListener("click", this._triggerElClickHandler), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._triggerEl && this._targetEl && this._initialized && (this._triggerEl && this._triggerEl.removeEventListener("click", this._triggerElClickHandler), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("CopyClipboard", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.getTargetValue = function() {
                        return "input" === this._options.contentType ? this._targetEl.value : "innerHTML" === this._options.contentType ? this._targetEl.innerHTML : "textContent" === this._options.contentType ? this._targetEl.textContent.replace(/\s+/g, " ").trim() : void 0;
                    }, t.prototype.copy = function() {
                        var t = this.getTargetValue();
                        this._options.htmlEntities && (t = this.decodeHTML(t));
                        var e = document.createElement("textarea");
                        return e.value = t, document.body.appendChild(e), e.select(), document.execCommand("copy"), document.body.removeChild(e), this._options.onCopy(this), t;
                    }, t.prototype.decodeHTML = function(t) {
                        var e = document.createElement("textarea");
                        return e.innerHTML = t, e.textContent;
                    }, t.prototype.updateOnCopyCallback = function(t) {
                        this._options.onCopy = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-copy-to-clipboard-target]").forEach(function(t) {
                        var e = t.getAttribute("data-copy-to-clipboard-target"), i = document.getElementById(e), n = t.getAttribute("data-copy-to-clipboard-content-type"), s = t.getAttribute("data-copy-to-clipboard-html-entities");
                        i ? o.default.instanceExists("CopyClipboard", i.getAttribute("id")) || new a(t, i, {
                            htmlEntities: !(!s || "true" !== s) || r.htmlEntities,
                            contentType: n || r.contentType
                        }) : console.error('The target element with id "'.concat(e, '" does not exist. Please check the data-copy-to-clipboard-target attribute.'));
                    });
                }
                e.initCopyClipboards = c, "undefined" != typeof window && (window.CopyClipboard = a, window.initClipboards = c), e.default = a;
            },
            922: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initCollapses = void 0;
                var o = i(423), r = {
                    onCollapse: function() {},
                    onExpand: function() {},
                    onToggle: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = r), void 0 === a && (a = s), this._instanceId = a.id ? a.id : t.id, this._targetEl = t, this._triggerEl = e, this._options = n(n({}, r), i), this._visible = !1, this._initialized = !1, this.init(), o.default.addInstance("Collapse", this, this._instanceId, a.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._triggerEl && this._targetEl && !this._initialized && (this._triggerEl.hasAttribute("aria-expanded") ? this._visible = "true" === this._triggerEl.getAttribute("aria-expanded") : this._visible = !this._targetEl.classList.contains("hidden"), this._clickHandler = function() {
                            t.toggle();
                        }, this._triggerEl.addEventListener("click", this._clickHandler), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._triggerEl && this._initialized && (this._triggerEl.removeEventListener("click", this._clickHandler), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Collapse", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.collapse = function() {
                        this._targetEl.classList.add("hidden"), this._triggerEl && this._triggerEl.setAttribute("aria-expanded", "false"), this._visible = !1, this._options.onCollapse(this);
                    }, t.prototype.expand = function() {
                        this._targetEl.classList.remove("hidden"), this._triggerEl && this._triggerEl.setAttribute("aria-expanded", "true"), this._visible = !0, this._options.onExpand(this);
                    }, t.prototype.toggle = function() {
                        this._visible ? this.collapse() : this.expand(), this._options.onToggle(this);
                    }, t.prototype.updateOnCollapse = function(t) {
                        this._options.onCollapse = t;
                    }, t.prototype.updateOnExpand = function(t) {
                        this._options.onExpand = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-collapse-toggle]").forEach(function(t) {
                        var e = t.getAttribute("data-collapse-toggle"), i = document.getElementById(e);
                        i ? o.default.instanceExists("Collapse", i.getAttribute("id")) ? new a(i, t, {}, {
                            id: i.getAttribute("id") + "_" + o.default._generateRandomId()
                        }) : new a(i, t) : console.error('The target element with id "'.concat(e, '" does not exist. Please check the data-collapse-toggle attribute.'));
                    });
                }
                e.initCollapses = c, "undefined" != typeof window && (window.Collapse = a, window.initCollapses = c), e.default = a;
            },
            556: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initDials = void 0;
                var o = i(423), r = {
                    triggerType: "hover",
                    onShow: function() {},
                    onHide: function() {},
                    onToggle: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a, c) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = null), void 0 === a && (a = r), void 0 === c && (c = s), this._instanceId = c.id ? c.id : i.id, this._parentEl = t, this._triggerEl = e, this._targetEl = i, this._options = n(n({}, r), a), this._visible = !1, this._initialized = !1, this.init(), o.default.addInstance("Dial", this, this._instanceId, c.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        if (this._triggerEl && this._targetEl && !this._initialized) {
                            var e = this._getTriggerEventTypes(this._options.triggerType);
                            this._showEventHandler = function() {
                                t.show();
                            }, e.showEvents.forEach(function(e) {
                                t._triggerEl.addEventListener(e, t._showEventHandler), t._targetEl.addEventListener(e, t._showEventHandler);
                            }), this._hideEventHandler = function() {
                                t._parentEl.matches(":hover") || t.hide();
                            }, e.hideEvents.forEach(function(e) {
                                t._parentEl.addEventListener(e, t._hideEventHandler);
                            }), this._initialized = !0;
                        }
                    }, t.prototype.destroy = function() {
                        var t = this;
                        if (this._initialized) {
                            var e = this._getTriggerEventTypes(this._options.triggerType);
                            e.showEvents.forEach(function(e) {
                                t._triggerEl.removeEventListener(e, t._showEventHandler), t._targetEl.removeEventListener(e, t._showEventHandler);
                            }), e.hideEvents.forEach(function(e) {
                                t._parentEl.removeEventListener(e, t._hideEventHandler);
                            }), this._initialized = !1;
                        }
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Dial", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.hide = function() {
                        this._targetEl.classList.add("hidden"), this._triggerEl && this._triggerEl.setAttribute("aria-expanded", "false"), this._visible = !1, this._options.onHide(this);
                    }, t.prototype.show = function() {
                        this._targetEl.classList.remove("hidden"), this._triggerEl && this._triggerEl.setAttribute("aria-expanded", "true"), this._visible = !0, this._options.onShow(this);
                    }, t.prototype.toggle = function() {
                        this._visible ? this.hide() : this.show();
                    }, t.prototype.isHidden = function() {
                        return !this._visible;
                    }, t.prototype.isVisible = function() {
                        return this._visible;
                    }, t.prototype._getTriggerEventTypes = function(t) {
                        switch(t){
                            case "hover":
                            default:
                                return {
                                    showEvents: [
                                        "mouseenter",
                                        "focus"
                                    ],
                                    hideEvents: [
                                        "mouseleave",
                                        "blur"
                                    ]
                                };
                            case "click":
                                return {
                                    showEvents: [
                                        "click",
                                        "focus"
                                    ],
                                    hideEvents: [
                                        "focusout",
                                        "blur"
                                    ]
                                };
                            case "none":
                                return {
                                    showEvents: [],
                                    hideEvents: []
                                };
                        }
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-dial-init]").forEach(function(t) {
                        var e = t.querySelector("[data-dial-toggle]");
                        if (e) {
                            var i = e.getAttribute("data-dial-toggle"), n = document.getElementById(i);
                            if (n) {
                                var o = e.getAttribute("data-dial-trigger");
                                new a(t, e, n, {
                                    triggerType: o || r.triggerType
                                });
                            } else console.error("Dial with id ".concat(i, " does not exist. Are you sure that the data-dial-toggle attribute points to the correct modal id?"));
                        } else console.error("Dial with id ".concat(t.id, " does not have a trigger element. Are you sure that the data-dial-toggle attribute exists?"));
                    });
                }
                e.initDials = c, "undefined" != typeof window && (window.Dial = a, window.initDials = c), e.default = a;
            },
            791: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initDismisses = void 0;
                var o = i(423), r = {
                    transition: "transition-opacity",
                    duration: 300,
                    timing: "ease-out",
                    onHide: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = r), void 0 === a && (a = s), this._instanceId = a.id ? a.id : t.id, this._targetEl = t, this._triggerEl = e, this._options = n(n({}, r), i), this._initialized = !1, this.init(), o.default.addInstance("Dismiss", this, this._instanceId, a.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._triggerEl && this._targetEl && !this._initialized && (this._clickHandler = function() {
                            t.hide();
                        }, this._triggerEl.addEventListener("click", this._clickHandler), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._triggerEl && this._initialized && (this._triggerEl.removeEventListener("click", this._clickHandler), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Dismiss", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.hide = function() {
                        var t = this;
                        this._targetEl.classList.add(this._options.transition, "duration-".concat(this._options.duration), this._options.timing, "opacity-0"), setTimeout(function() {
                            t._targetEl.classList.add("hidden");
                        }, this._options.duration), this._options.onHide(this, this._targetEl);
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-dismiss-target]").forEach(function(t) {
                        var e = t.getAttribute("data-dismiss-target"), i = document.querySelector(e);
                        i ? new a(i, t) : console.error('The dismiss element with id "'.concat(e, '" does not exist. Please check the data-dismiss-target attribute.'));
                    });
                }
                e.initDismisses = c, "undefined" != typeof window && (window.Dismiss = a, window.initDismisses = c), e.default = a;
            },
            340: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initDrawers = void 0;
                var o = i(423), r = {
                    placement: "left",
                    bodyScrolling: !1,
                    backdrop: !0,
                    edge: !1,
                    edgeOffset: "bottom-[60px]",
                    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
                    onShow: function() {},
                    onHide: function() {},
                    onToggle: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i) {
                        void 0 === t && (t = null), void 0 === e && (e = r), void 0 === i && (i = s), this._eventListenerInstances = [], this._instanceId = i.id ? i.id : t.id, this._targetEl = t, this._options = n(n({}, r), e), this._visible = !1, this._initialized = !1, this.init(), o.default.addInstance("Drawer", this, this._instanceId, i.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._targetEl && !this._initialized && (this._targetEl.setAttribute("aria-hidden", "true"), this._targetEl.classList.add("transition-transform"), this._getPlacementClasses(this._options.placement).base.map(function(e) {
                            t._targetEl.classList.add(e);
                        }), this._handleEscapeKey = function(e) {
                            "Escape" === e.key && t.isVisible() && t.hide();
                        }, document.addEventListener("keydown", this._handleEscapeKey), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._initialized && (this.removeAllEventListenerInstances(), this._destroyBackdropEl(), document.removeEventListener("keydown", this._handleEscapeKey), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Drawer", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.hide = function() {
                        var t = this;
                        this._options.edge ? (this._getPlacementClasses(this._options.placement + "-edge").active.map(function(e) {
                            t._targetEl.classList.remove(e);
                        }), this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(e) {
                            t._targetEl.classList.add(e);
                        })) : (this._getPlacementClasses(this._options.placement).active.map(function(e) {
                            t._targetEl.classList.remove(e);
                        }), this._getPlacementClasses(this._options.placement).inactive.map(function(e) {
                            t._targetEl.classList.add(e);
                        })), this._targetEl.setAttribute("aria-hidden", "true"), this._targetEl.removeAttribute("aria-modal"), this._targetEl.removeAttribute("role"), this._options.bodyScrolling || document.body.classList.remove("overflow-hidden"), this._options.backdrop && this._destroyBackdropEl(), this._visible = !1, this._options.onHide(this);
                    }, t.prototype.show = function() {
                        var t = this;
                        this._options.edge ? (this._getPlacementClasses(this._options.placement + "-edge").active.map(function(e) {
                            t._targetEl.classList.add(e);
                        }), this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(e) {
                            t._targetEl.classList.remove(e);
                        })) : (this._getPlacementClasses(this._options.placement).active.map(function(e) {
                            t._targetEl.classList.add(e);
                        }), this._getPlacementClasses(this._options.placement).inactive.map(function(e) {
                            t._targetEl.classList.remove(e);
                        })), this._targetEl.setAttribute("aria-modal", "true"), this._targetEl.setAttribute("role", "dialog"), this._targetEl.removeAttribute("aria-hidden"), this._options.bodyScrolling || document.body.classList.add("overflow-hidden"), this._options.backdrop && this._createBackdrop(), this._visible = !0, this._options.onShow(this);
                    }, t.prototype.toggle = function() {
                        this.isVisible() ? this.hide() : this.show();
                    }, t.prototype._createBackdrop = function() {
                        var t, e = this;
                        if (!this._visible) {
                            var i = document.createElement("div");
                            i.setAttribute("drawer-backdrop", ""), (t = i.classList).add.apply(t, this._options.backdropClasses.split(" ")), document.querySelector("body").append(i), i.addEventListener("click", function() {
                                e.hide();
                            });
                        }
                    }, t.prototype._destroyBackdropEl = function() {
                        this._visible && null !== document.querySelector("[drawer-backdrop]") && document.querySelector("[drawer-backdrop]").remove();
                    }, t.prototype._getPlacementClasses = function(t) {
                        switch(t){
                            case "top":
                                return {
                                    base: [
                                        "top-0",
                                        "left-0",
                                        "right-0"
                                    ],
                                    active: [
                                        "transform-none"
                                    ],
                                    inactive: [
                                        "-translate-y-full"
                                    ]
                                };
                            case "right":
                                return {
                                    base: [
                                        "right-0",
                                        "top-0"
                                    ],
                                    active: [
                                        "transform-none"
                                    ],
                                    inactive: [
                                        "translate-x-full"
                                    ]
                                };
                            case "bottom":
                                return {
                                    base: [
                                        "bottom-0",
                                        "left-0",
                                        "right-0"
                                    ],
                                    active: [
                                        "transform-none"
                                    ],
                                    inactive: [
                                        "translate-y-full"
                                    ]
                                };
                            case "left":
                            default:
                                return {
                                    base: [
                                        "left-0",
                                        "top-0"
                                    ],
                                    active: [
                                        "transform-none"
                                    ],
                                    inactive: [
                                        "-translate-x-full"
                                    ]
                                };
                            case "bottom-edge":
                                return {
                                    base: [
                                        "left-0",
                                        "top-0"
                                    ],
                                    active: [
                                        "transform-none"
                                    ],
                                    inactive: [
                                        "translate-y-full",
                                        this._options.edgeOffset
                                    ]
                                };
                        }
                    }, t.prototype.isHidden = function() {
                        return !this._visible;
                    }, t.prototype.isVisible = function() {
                        return this._visible;
                    }, t.prototype.addEventListenerInstance = function(t, e, i) {
                        this._eventListenerInstances.push({
                            element: t,
                            type: e,
                            handler: i
                        });
                    }, t.prototype.removeAllEventListenerInstances = function() {
                        this._eventListenerInstances.map(function(t) {
                            t.element.removeEventListener(t.type, t.handler);
                        }), this._eventListenerInstances = [];
                    }, t.prototype.getAllEventListenerInstances = function() {
                        return this._eventListenerInstances;
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-drawer-target]").forEach(function(t) {
                        var e = t.getAttribute("data-drawer-target"), i = document.getElementById(e);
                        if (i) {
                            var n = t.getAttribute("data-drawer-placement"), o = t.getAttribute("data-drawer-body-scrolling"), s = t.getAttribute("data-drawer-backdrop"), c = t.getAttribute("data-drawer-edge"), d = t.getAttribute("data-drawer-edge-offset");
                            new a(i, {
                                placement: n || r.placement,
                                bodyScrolling: o ? "true" === o : r.bodyScrolling,
                                backdrop: s ? "true" === s : r.backdrop,
                                edge: c ? "true" === c : r.edge,
                                edgeOffset: d || r.edgeOffset
                            });
                        } else console.error("Drawer with id ".concat(e, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
                    }), document.querySelectorAll("[data-drawer-toggle]").forEach(function(t) {
                        var e = t.getAttribute("data-drawer-toggle");
                        if (document.getElementById(e)) {
                            var i = o.default.getInstance("Drawer", e);
                            if (i) {
                                var n = function() {
                                    i.toggle();
                                };
                                t.addEventListener("click", n), i.addEventListenerInstance(t, "click", n);
                            } else console.error("Drawer with id ".concat(e, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
                        } else console.error("Drawer with id ".concat(e, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
                    }), document.querySelectorAll("[data-drawer-dismiss], [data-drawer-hide]").forEach(function(t) {
                        var e = t.getAttribute("data-drawer-dismiss") ? t.getAttribute("data-drawer-dismiss") : t.getAttribute("data-drawer-hide");
                        if (document.getElementById(e)) {
                            var i = o.default.getInstance("Drawer", e);
                            if (i) {
                                var n = function() {
                                    i.hide();
                                };
                                t.addEventListener("click", n), i.addEventListenerInstance(t, "click", n);
                            } else console.error("Drawer with id ".concat(e, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
                        } else console.error("Drawer with id ".concat(e, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id"));
                    }), document.querySelectorAll("[data-drawer-show]").forEach(function(t) {
                        var e = t.getAttribute("data-drawer-show");
                        if (document.getElementById(e)) {
                            var i = o.default.getInstance("Drawer", e);
                            if (i) {
                                var n = function() {
                                    i.show();
                                };
                                t.addEventListener("click", n), i.addEventListenerInstance(t, "click", n);
                            } else console.error("Drawer with id ".concat(e, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
                        } else console.error("Drawer with id ".concat(e, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
                    });
                }
                e.initDrawers = c, "undefined" != typeof window && (window.Drawer = a, window.initDrawers = c), e.default = a;
            },
            316: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                }, o = this && this.__spreadArray || function(t, e, i) {
                    if (i || 2 === arguments.length) for(var n, o = 0, r = e.length; o < r; o++)!n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
                    return t.concat(n || Array.prototype.slice.call(e));
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initDropdowns = void 0;
                var r = i(853), s = i(423), a = {
                    placement: "bottom",
                    triggerType: "click",
                    offsetSkidding: 0,
                    offsetDistance: 10,
                    delay: 300,
                    ignoreClickOutsideClass: !1,
                    onShow: function() {},
                    onHide: function() {},
                    onToggle: function() {}
                }, c = {
                    id: null,
                    override: !0
                }, d = function() {
                    function t(t, e, i, o) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = a), void 0 === o && (o = c), this._instanceId = o.id ? o.id : t.id, this._targetEl = t, this._triggerEl = e, this._options = n(n({}, a), i), this._popperInstance = null, this._visible = !1, this._initialized = !1, this.init(), s.default.addInstance("Dropdown", this, this._instanceId, o.override);
                    }
                    return t.prototype.init = function() {
                        this._triggerEl && this._targetEl && !this._initialized && (this._popperInstance = this._createPopperInstance(), this._setupEventListeners(), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        var t = this, e = this._getTriggerEvents();
                        "click" === this._options.triggerType && e.showEvents.forEach(function(e) {
                            t._triggerEl.removeEventListener(e, t._clickHandler);
                        }), "hover" === this._options.triggerType && (e.showEvents.forEach(function(e) {
                            t._triggerEl.removeEventListener(e, t._hoverShowTriggerElHandler), t._targetEl.removeEventListener(e, t._hoverShowTargetElHandler);
                        }), e.hideEvents.forEach(function(e) {
                            t._triggerEl.removeEventListener(e, t._hoverHideHandler), t._targetEl.removeEventListener(e, t._hoverHideHandler);
                        })), this._popperInstance.destroy(), this._initialized = !1;
                    }, t.prototype.removeInstance = function() {
                        s.default.removeInstance("Dropdown", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype._setupEventListeners = function() {
                        var t = this, e = this._getTriggerEvents();
                        this._clickHandler = function() {
                            t.toggle();
                        }, "click" === this._options.triggerType && e.showEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._clickHandler);
                        }), this._hoverShowTriggerElHandler = function(e) {
                            "click" === e.type ? t.toggle() : setTimeout(function() {
                                t.show();
                            }, t._options.delay);
                        }, this._hoverShowTargetElHandler = function() {
                            t.show();
                        }, this._hoverHideHandler = function() {
                            setTimeout(function() {
                                t._targetEl.matches(":hover") || t.hide();
                            }, t._options.delay);
                        }, "hover" === this._options.triggerType && (e.showEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._hoverShowTriggerElHandler), t._targetEl.addEventListener(e, t._hoverShowTargetElHandler);
                        }), e.hideEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._hoverHideHandler), t._targetEl.addEventListener(e, t._hoverHideHandler);
                        }));
                    }, t.prototype._createPopperInstance = function() {
                        return (0, r.createPopper)(this._triggerEl, this._targetEl, {
                            placement: this._options.placement,
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [
                                            this._options.offsetSkidding,
                                            this._options.offsetDistance
                                        ]
                                    }
                                }
                            ]
                        });
                    }, t.prototype._setupClickOutsideListener = function() {
                        var t = this;
                        this._clickOutsideEventListener = function(e) {
                            t._handleClickOutside(e, t._targetEl);
                        }, document.body.addEventListener("click", this._clickOutsideEventListener, !0);
                    }, t.prototype._removeClickOutsideListener = function() {
                        document.body.removeEventListener("click", this._clickOutsideEventListener, !0);
                    }, t.prototype._handleClickOutside = function(t, e) {
                        var i = t.target, n = this._options.ignoreClickOutsideClass, o = !1;
                        n && document.querySelectorAll(".".concat(n)).forEach(function(t) {
                            t.contains(i) && (o = !0);
                        });
                        i === e || e.contains(i) || this._triggerEl.contains(i) || o || !this.isVisible() || this.hide();
                    }, t.prototype._getTriggerEvents = function() {
                        switch(this._options.triggerType){
                            case "hover":
                                return {
                                    showEvents: [
                                        "mouseenter",
                                        "click"
                                    ],
                                    hideEvents: [
                                        "mouseleave"
                                    ]
                                };
                            case "click":
                            default:
                                return {
                                    showEvents: [
                                        "click"
                                    ],
                                    hideEvents: []
                                };
                            case "none":
                                return {
                                    showEvents: [],
                                    hideEvents: []
                                };
                        }
                    }, t.prototype.toggle = function() {
                        this.isVisible() ? this.hide() : this.show(), this._options.onToggle(this);
                    }, t.prototype.isVisible = function() {
                        return this._visible;
                    }, t.prototype.show = function() {
                        this._targetEl.classList.remove("hidden"), this._targetEl.classList.add("block"), this._popperInstance.setOptions(function(t) {
                            return n(n({}, t), {
                                modifiers: o(o([], t.modifiers, !0), [
                                    {
                                        name: "eventListeners",
                                        enabled: !0
                                    }
                                ], !1)
                            });
                        }), this._setupClickOutsideListener(), this._popperInstance.update(), this._visible = !0, this._options.onShow(this);
                    }, t.prototype.hide = function() {
                        this._targetEl.classList.remove("block"), this._targetEl.classList.add("hidden"), this._popperInstance.setOptions(function(t) {
                            return n(n({}, t), {
                                modifiers: o(o([], t.modifiers, !0), [
                                    {
                                        name: "eventListeners",
                                        enabled: !1
                                    }
                                ], !1)
                            });
                        }), this._visible = !1, this._removeClickOutsideListener(), this._options.onHide(this);
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function l() {
                    document.querySelectorAll("[data-dropdown-toggle]").forEach(function(t) {
                        var e = t.getAttribute("data-dropdown-toggle"), i = document.getElementById(e);
                        if (i) {
                            var n = t.getAttribute("data-dropdown-placement"), o = t.getAttribute("data-dropdown-offset-skidding"), r = t.getAttribute("data-dropdown-offset-distance"), s = t.getAttribute("data-dropdown-trigger"), c = t.getAttribute("data-dropdown-delay"), l = t.getAttribute("data-dropdown-ignore-click-outside-class");
                            new d(i, t, {
                                placement: n || a.placement,
                                triggerType: s || a.triggerType,
                                offsetSkidding: o ? parseInt(o) : a.offsetSkidding,
                                offsetDistance: r ? parseInt(r) : a.offsetDistance,
                                delay: c ? parseInt(c) : a.delay,
                                ignoreClickOutsideClass: l || a.ignoreClickOutsideClass
                            });
                        } else console.error('The dropdown element with id "'.concat(e, '" does not exist. Please check the data-dropdown-toggle attribute.'));
                    });
                }
                e.initDropdowns = l, "undefined" != typeof window && (window.Dropdown = d, window.initDropdowns = l), e.default = d;
            },
            311: function(t, e, i) {
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initFlowbite = void 0;
                var n = i(902), o = i(33), r = i(673), s = i(922), a = i(556), c = i(791), d = i(340), l = i(316), u = i(656), p = i(16), h = i(903), f = i(247), v = i(671);
                function g() {
                    (0, n.initAccordions)(), (0, s.initCollapses)(), (0, o.initCarousels)(), (0, c.initDismisses)(), (0, l.initDropdowns)(), (0, p.initModals)(), (0, d.initDrawers)(), (0, f.initTabs)(), (0, v.initTooltips)(), (0, h.initPopovers)(), (0, a.initDials)(), (0, u.initInputCounters)(), (0, r.initCopyClipboards)();
                }
                e.initFlowbite = g, "undefined" != typeof window && (window.initFlowbite = g);
            },
            656: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initInputCounters = void 0;
                var o = i(423), r = {
                    minValue: null,
                    maxValue: null,
                    onIncrement: function() {},
                    onDecrement: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a, c) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = null), void 0 === a && (a = r), void 0 === c && (c = s), this._instanceId = c.id ? c.id : t.id, this._targetEl = t, this._incrementEl = e, this._decrementEl = i, this._options = n(n({}, r), a), this._initialized = !1, this.init(), o.default.addInstance("InputCounter", this, this._instanceId, c.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._targetEl && !this._initialized && (this._inputHandler = function(e) {
                            var i = e.target;
                            /^\d*$/.test(i.value) || (i.value = i.value.replace(/[^\d]/g, "")), null !== t._options.maxValue && parseInt(i.value) > t._options.maxValue && (i.value = t._options.maxValue.toString()), null !== t._options.minValue && parseInt(i.value) < t._options.minValue && (i.value = t._options.minValue.toString());
                        }, this._incrementClickHandler = function() {
                            t.increment();
                        }, this._decrementClickHandler = function() {
                            t.decrement();
                        }, this._targetEl.addEventListener("input", this._inputHandler), this._incrementEl && this._incrementEl.addEventListener("click", this._incrementClickHandler), this._decrementEl && this._decrementEl.addEventListener("click", this._decrementClickHandler), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._targetEl && this._initialized && (this._targetEl.removeEventListener("input", this._inputHandler), this._incrementEl && this._incrementEl.removeEventListener("click", this._incrementClickHandler), this._decrementEl && this._decrementEl.removeEventListener("click", this._decrementClickHandler), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("InputCounter", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.getCurrentValue = function() {
                        return parseInt(this._targetEl.value) || 0;
                    }, t.prototype.increment = function() {
                        null !== this._options.maxValue && this.getCurrentValue() >= this._options.maxValue || (this._targetEl.value = (this.getCurrentValue() + 1).toString(), this._options.onIncrement(this));
                    }, t.prototype.decrement = function() {
                        null !== this._options.minValue && this.getCurrentValue() <= this._options.minValue || (this._targetEl.value = (this.getCurrentValue() - 1).toString(), this._options.onDecrement(this));
                    }, t.prototype.updateOnIncrement = function(t) {
                        this._options.onIncrement = t;
                    }, t.prototype.updateOnDecrement = function(t) {
                        this._options.onDecrement = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-input-counter]").forEach(function(t) {
                        var e = t.id, i = document.querySelector('[data-input-counter-increment="' + e + '"]'), n = document.querySelector('[data-input-counter-decrement="' + e + '"]'), r = t.getAttribute("data-input-counter-min"), s = t.getAttribute("data-input-counter-max");
                        t ? o.default.instanceExists("InputCounter", t.getAttribute("id")) || new a(t, i || null, n || null, {
                            minValue: r ? parseInt(r) : null,
                            maxValue: s ? parseInt(s) : null
                        }) : console.error('The target element with id "'.concat(e, '" does not exist. Please check the data-input-counter attribute.'));
                    });
                }
                e.initInputCounters = c, "undefined" != typeof window && (window.InputCounter = a, window.initInputCounters = c), e.default = a;
            },
            16: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initModals = void 0;
                var o = i(423), r = {
                    placement: "center",
                    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
                    backdrop: "dynamic",
                    closable: !0,
                    onHide: function() {},
                    onShow: function() {},
                    onToggle: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i) {
                        void 0 === t && (t = null), void 0 === e && (e = r), void 0 === i && (i = s), this._eventListenerInstances = [], this._instanceId = i.id ? i.id : t.id, this._targetEl = t, this._options = n(n({}, r), e), this._isHidden = !0, this._backdropEl = null, this._initialized = !1, this.init(), o.default.addInstance("Modal", this, this._instanceId, i.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._targetEl && !this._initialized && (this._getPlacementClasses().map(function(e) {
                            t._targetEl.classList.add(e);
                        }), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        this._initialized && (this.removeAllEventListenerInstances(), this._destroyBackdropEl(), this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        o.default.removeInstance("Modal", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype._createBackdrop = function() {
                        var t;
                        if (this._isHidden) {
                            var e = document.createElement("div");
                            e.setAttribute("modal-backdrop", ""), (t = e.classList).add.apply(t, this._options.backdropClasses.split(" ")), document.querySelector("body").append(e), this._backdropEl = e;
                        }
                    }, t.prototype._destroyBackdropEl = function() {
                        this._isHidden || document.querySelector("[modal-backdrop]").remove();
                    }, t.prototype._setupModalCloseEventListeners = function() {
                        var t = this;
                        "dynamic" === this._options.backdrop && (this._clickOutsideEventListener = function(e) {
                            t._handleOutsideClick(e.target);
                        }, this._targetEl.addEventListener("click", this._clickOutsideEventListener, !0)), this._keydownEventListener = function(e) {
                            "Escape" === e.key && t.hide();
                        }, document.body.addEventListener("keydown", this._keydownEventListener, !0);
                    }, t.prototype._removeModalCloseEventListeners = function() {
                        "dynamic" === this._options.backdrop && this._targetEl.removeEventListener("click", this._clickOutsideEventListener, !0), document.body.removeEventListener("keydown", this._keydownEventListener, !0);
                    }, t.prototype._handleOutsideClick = function(t) {
                        (t === this._targetEl || t === this._backdropEl && this.isVisible()) && this.hide();
                    }, t.prototype._getPlacementClasses = function() {
                        switch(this._options.placement){
                            case "top-left":
                                return [
                                    "justify-start",
                                    "items-start"
                                ];
                            case "top-center":
                                return [
                                    "justify-center",
                                    "items-start"
                                ];
                            case "top-right":
                                return [
                                    "justify-end",
                                    "items-start"
                                ];
                            case "center-left":
                                return [
                                    "justify-start",
                                    "items-center"
                                ];
                            case "center":
                            default:
                                return [
                                    "justify-center",
                                    "items-center"
                                ];
                            case "center-right":
                                return [
                                    "justify-end",
                                    "items-center"
                                ];
                            case "bottom-left":
                                return [
                                    "justify-start",
                                    "items-end"
                                ];
                            case "bottom-center":
                                return [
                                    "justify-center",
                                    "items-end"
                                ];
                            case "bottom-right":
                                return [
                                    "justify-end",
                                    "items-end"
                                ];
                        }
                    }, t.prototype.toggle = function() {
                        this._isHidden ? this.show() : this.hide(), this._options.onToggle(this);
                    }, t.prototype.show = function() {
                        this.isHidden && (this._targetEl.classList.add("flex"), this._targetEl.classList.remove("hidden"), this._targetEl.setAttribute("aria-modal", "true"), this._targetEl.setAttribute("role", "dialog"), this._targetEl.removeAttribute("aria-hidden"), this._createBackdrop(), this._isHidden = !1, this._options.closable && this._setupModalCloseEventListeners(), document.body.classList.add("overflow-hidden"), this._options.onShow(this));
                    }, t.prototype.hide = function() {
                        this.isVisible && (this._targetEl.classList.add("hidden"), this._targetEl.classList.remove("flex"), this._targetEl.setAttribute("aria-hidden", "true"), this._targetEl.removeAttribute("aria-modal"), this._targetEl.removeAttribute("role"), this._destroyBackdropEl(), this._isHidden = !0, document.body.classList.remove("overflow-hidden"), this._options.closable && this._removeModalCloseEventListeners(), this._options.onHide(this));
                    }, t.prototype.isVisible = function() {
                        return !this._isHidden;
                    }, t.prototype.isHidden = function() {
                        return this._isHidden;
                    }, t.prototype.addEventListenerInstance = function(t, e, i) {
                        this._eventListenerInstances.push({
                            element: t,
                            type: e,
                            handler: i
                        });
                    }, t.prototype.removeAllEventListenerInstances = function() {
                        this._eventListenerInstances.map(function(t) {
                            t.element.removeEventListener(t.type, t.handler);
                        }), this._eventListenerInstances = [];
                    }, t.prototype.getAllEventListenerInstances = function() {
                        return this._eventListenerInstances;
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-modal-target]").forEach(function(t) {
                        var e = t.getAttribute("data-modal-target"), i = document.getElementById(e);
                        if (i) {
                            var n = i.getAttribute("data-modal-placement"), o = i.getAttribute("data-modal-backdrop");
                            new a(i, {
                                placement: n || r.placement,
                                backdrop: o || r.backdrop
                            });
                        } else console.error("Modal with id ".concat(e, " does not exist. Are you sure that the data-modal-target attribute points to the correct modal id?."));
                    }), document.querySelectorAll("[data-modal-toggle]").forEach(function(t) {
                        var e = t.getAttribute("data-modal-toggle");
                        if (document.getElementById(e)) {
                            var i = o.default.getInstance("Modal", e);
                            if (i) {
                                var n = function() {
                                    i.toggle();
                                };
                                t.addEventListener("click", n), i.addEventListenerInstance(t, "click", n);
                            } else console.error("Modal with id ".concat(e, " has not been initialized. Please initialize it using the data-modal-target attribute."));
                        } else console.error("Modal with id ".concat(e, " does not exist. Are you sure that the data-modal-toggle attribute points to the correct modal id?"));
                    }), document.querySelectorAll("[data-modal-show]").forEach(function(t) {
                        var e = t.getAttribute("data-modal-show");
                        if (document.getElementById(e)) {
                            var i = o.default.getInstance("Modal", e);
                            if (i) {
                                var n = function() {
                                    i.show();
                                };
                                t.addEventListener("click", n), i.addEventListenerInstance(t, "click", n);
                            } else console.error("Modal with id ".concat(e, " has not been initialized. Please initialize it using the data-modal-target attribute."));
                        } else console.error("Modal with id ".concat(e, " does not exist. Are you sure that the data-modal-show attribute points to the correct modal id?"));
                    }), document.querySelectorAll("[data-modal-hide]").forEach(function(t) {
                        var e = t.getAttribute("data-modal-hide");
                        if (document.getElementById(e)) {
                            var i = o.default.getInstance("Modal", e);
                            if (i) {
                                var n = function() {
                                    i.hide();
                                };
                                t.addEventListener("click", n), i.addEventListenerInstance(t, "click", n);
                            } else console.error("Modal with id ".concat(e, " has not been initialized. Please initialize it using the data-modal-target attribute."));
                        } else console.error("Modal with id ".concat(e, " does not exist. Are you sure that the data-modal-hide attribute points to the correct modal id?"));
                    });
                }
                e.initModals = c, "undefined" != typeof window && (window.Modal = a, window.initModals = c), e.default = a;
            },
            903: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                }, o = this && this.__spreadArray || function(t, e, i) {
                    if (i || 2 === arguments.length) for(var n, o = 0, r = e.length; o < r; o++)!n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
                    return t.concat(n || Array.prototype.slice.call(e));
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initPopovers = void 0;
                var r = i(853), s = i(423), a = {
                    placement: "top",
                    offset: 10,
                    triggerType: "hover",
                    onShow: function() {},
                    onHide: function() {},
                    onToggle: function() {}
                }, c = {
                    id: null,
                    override: !0
                }, d = function() {
                    function t(t, e, i, o) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = a), void 0 === o && (o = c), this._instanceId = o.id ? o.id : t.id, this._targetEl = t, this._triggerEl = e, this._options = n(n({}, a), i), this._popperInstance = null, this._visible = !1, this._initialized = !1, this.init(), s.default.addInstance("Popover", this, o.id ? o.id : this._targetEl.id, o.override);
                    }
                    return t.prototype.init = function() {
                        this._triggerEl && this._targetEl && !this._initialized && (this._setupEventListeners(), this._popperInstance = this._createPopperInstance(), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        var t = this;
                        if (this._initialized) {
                            var e = this._getTriggerEvents();
                            e.showEvents.forEach(function(e) {
                                t._triggerEl.removeEventListener(e, t._showHandler), t._targetEl.removeEventListener(e, t._showHandler);
                            }), e.hideEvents.forEach(function(e) {
                                t._triggerEl.removeEventListener(e, t._hideHandler), t._targetEl.removeEventListener(e, t._hideHandler);
                            }), this._removeKeydownListener(), this._removeClickOutsideListener(), this._popperInstance && this._popperInstance.destroy(), this._initialized = !1;
                        }
                    }, t.prototype.removeInstance = function() {
                        s.default.removeInstance("Popover", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype._setupEventListeners = function() {
                        var t = this, e = this._getTriggerEvents();
                        this._showHandler = function() {
                            t.show();
                        }, this._hideHandler = function() {
                            setTimeout(function() {
                                t._targetEl.matches(":hover") || t.hide();
                            }, 100);
                        }, e.showEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._showHandler), t._targetEl.addEventListener(e, t._showHandler);
                        }), e.hideEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._hideHandler), t._targetEl.addEventListener(e, t._hideHandler);
                        });
                    }, t.prototype._createPopperInstance = function() {
                        return (0, r.createPopper)(this._triggerEl, this._targetEl, {
                            placement: this._options.placement,
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [
                                            0,
                                            this._options.offset
                                        ]
                                    }
                                }
                            ]
                        });
                    }, t.prototype._getTriggerEvents = function() {
                        switch(this._options.triggerType){
                            case "hover":
                            default:
                                return {
                                    showEvents: [
                                        "mouseenter",
                                        "focus"
                                    ],
                                    hideEvents: [
                                        "mouseleave",
                                        "blur"
                                    ]
                                };
                            case "click":
                                return {
                                    showEvents: [
                                        "click",
                                        "focus"
                                    ],
                                    hideEvents: [
                                        "focusout",
                                        "blur"
                                    ]
                                };
                            case "none":
                                return {
                                    showEvents: [],
                                    hideEvents: []
                                };
                        }
                    }, t.prototype._setupKeydownListener = function() {
                        var t = this;
                        this._keydownEventListener = function(e) {
                            "Escape" === e.key && t.hide();
                        }, document.body.addEventListener("keydown", this._keydownEventListener, !0);
                    }, t.prototype._removeKeydownListener = function() {
                        document.body.removeEventListener("keydown", this._keydownEventListener, !0);
                    }, t.prototype._setupClickOutsideListener = function() {
                        var t = this;
                        this._clickOutsideEventListener = function(e) {
                            t._handleClickOutside(e, t._targetEl);
                        }, document.body.addEventListener("click", this._clickOutsideEventListener, !0);
                    }, t.prototype._removeClickOutsideListener = function() {
                        document.body.removeEventListener("click", this._clickOutsideEventListener, !0);
                    }, t.prototype._handleClickOutside = function(t, e) {
                        var i = t.target;
                        i === e || e.contains(i) || this._triggerEl.contains(i) || !this.isVisible() || this.hide();
                    }, t.prototype.isVisible = function() {
                        return this._visible;
                    }, t.prototype.toggle = function() {
                        this.isVisible() ? this.hide() : this.show(), this._options.onToggle(this);
                    }, t.prototype.show = function() {
                        this._targetEl.classList.remove("opacity-0", "invisible"), this._targetEl.classList.add("opacity-100", "visible"), this._popperInstance.setOptions(function(t) {
                            return n(n({}, t), {
                                modifiers: o(o([], t.modifiers, !0), [
                                    {
                                        name: "eventListeners",
                                        enabled: !0
                                    }
                                ], !1)
                            });
                        }), this._setupClickOutsideListener(), this._setupKeydownListener(), this._popperInstance.update(), this._visible = !0, this._options.onShow(this);
                    }, t.prototype.hide = function() {
                        this._targetEl.classList.remove("opacity-100", "visible"), this._targetEl.classList.add("opacity-0", "invisible"), this._popperInstance.setOptions(function(t) {
                            return n(n({}, t), {
                                modifiers: o(o([], t.modifiers, !0), [
                                    {
                                        name: "eventListeners",
                                        enabled: !1
                                    }
                                ], !1)
                            });
                        }), this._removeClickOutsideListener(), this._removeKeydownListener(), this._visible = !1, this._options.onHide(this);
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function l() {
                    document.querySelectorAll("[data-popover-target]").forEach(function(t) {
                        var e = t.getAttribute("data-popover-target"), i = document.getElementById(e);
                        if (i) {
                            var n = t.getAttribute("data-popover-trigger"), o = t.getAttribute("data-popover-placement"), r = t.getAttribute("data-popover-offset");
                            new d(i, t, {
                                placement: o || a.placement,
                                offset: r ? parseInt(r) : a.offset,
                                triggerType: n || a.triggerType
                            });
                        } else console.error('The popover element with id "'.concat(e, '" does not exist. Please check the data-popover-target attribute.'));
                    });
                }
                e.initPopovers = l, "undefined" != typeof window && (window.Popover = d, window.initPopovers = l), e.default = d;
            },
            247: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initTabs = void 0;
                var o = i(423), r = {
                    defaultTabId: null,
                    activeClasses: "text-blue-600 hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 border-blue-600 dark:border-blue-500",
                    inactiveClasses: "dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300",
                    onShow: function() {}
                }, s = {
                    id: null,
                    override: !0
                }, a = function() {
                    function t(t, e, i, a) {
                        void 0 === t && (t = null), void 0 === e && (e = []), void 0 === i && (i = r), void 0 === a && (a = s), this._instanceId = a.id ? a.id : t.id, this._tabsEl = t, this._items = e, this._activeTab = i ? this.getTab(i.defaultTabId) : null, this._options = n(n({}, r), i), this._initialized = !1, this.init(), o.default.addInstance("Tabs", this, this._tabsEl.id, !0), o.default.addInstance("Tabs", this, this._instanceId, a.override);
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._items.length && !this._initialized && (this._activeTab || this.setActiveTab(this._items[0]), this.show(this._activeTab.id, !0), this._items.map(function(e) {
                            e.triggerEl.addEventListener("click", function(i) {
                                i.preventDefault(), t.show(e.id);
                            });
                        }));
                    }, t.prototype.destroy = function() {
                        this._initialized && (this._initialized = !1);
                    }, t.prototype.removeInstance = function() {
                        this.destroy(), o.default.removeInstance("Tabs", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype.getActiveTab = function() {
                        return this._activeTab;
                    }, t.prototype.setActiveTab = function(t) {
                        this._activeTab = t;
                    }, t.prototype.getTab = function(t) {
                        return this._items.filter(function(e) {
                            return e.id === t;
                        })[0];
                    }, t.prototype.show = function(t, e) {
                        var i, n, o = this;
                        void 0 === e && (e = !1);
                        var r = this.getTab(t);
                        (r !== this._activeTab || e) && (this._items.map(function(t) {
                            var e, i;
                            t !== r && ((e = t.triggerEl.classList).remove.apply(e, o._options.activeClasses.split(" ")), (i = t.triggerEl.classList).add.apply(i, o._options.inactiveClasses.split(" ")), t.targetEl.classList.add("hidden"), t.triggerEl.setAttribute("aria-selected", "false"));
                        }), (i = r.triggerEl.classList).add.apply(i, this._options.activeClasses.split(" ")), (n = r.triggerEl.classList).remove.apply(n, this._options.inactiveClasses.split(" ")), r.triggerEl.setAttribute("aria-selected", "true"), r.targetEl.classList.remove("hidden"), this.setActiveTab(r), this._options.onShow(this, r));
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t;
                }();
                function c() {
                    document.querySelectorAll("[data-tabs-toggle]").forEach(function(t) {
                        var e = [], i = t.getAttribute("data-tabs-active-classes"), n = t.getAttribute("data-tabs-inactive-classes"), o = null;
                        t.querySelectorAll('[role="tab"]').forEach(function(t) {
                            var i = "true" === t.getAttribute("aria-selected"), n = {
                                id: t.getAttribute("data-tabs-target"),
                                triggerEl: t,
                                targetEl: document.querySelector(t.getAttribute("data-tabs-target"))
                            };
                            e.push(n), i && (o = n.id);
                        }), new a(t, e, {
                            defaultTabId: o,
                            activeClasses: i || r.activeClasses,
                            inactiveClasses: n || r.inactiveClasses
                        });
                    });
                }
                e.initTabs = c, "undefined" != typeof window && (window.Tabs = a, window.initTabs = c), e.default = a;
            },
            671: function(t, e, i) {
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        return t;
                    }, n.apply(this, arguments);
                }, o = this && this.__spreadArray || function(t, e, i) {
                    if (i || 2 === arguments.length) for(var n, o = 0, r = e.length; o < r; o++)!n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
                    return t.concat(n || Array.prototype.slice.call(e));
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.initTooltips = void 0;
                var r = i(853), s = i(423), a = {
                    placement: "top",
                    triggerType: "hover",
                    onShow: function() {},
                    onHide: function() {},
                    onToggle: function() {}
                }, c = {
                    id: null,
                    override: !0
                }, d = function() {
                    function t(t, e, i, o) {
                        void 0 === t && (t = null), void 0 === e && (e = null), void 0 === i && (i = a), void 0 === o && (o = c), this._instanceId = o.id ? o.id : t.id, this._targetEl = t, this._triggerEl = e, this._options = n(n({}, a), i), this._popperInstance = null, this._visible = !1, this._initialized = !1, this.init(), s.default.addInstance("Tooltip", this, this._instanceId, o.override);
                    }
                    return t.prototype.init = function() {
                        this._triggerEl && this._targetEl && !this._initialized && (this._setupEventListeners(), this._popperInstance = this._createPopperInstance(), this._initialized = !0);
                    }, t.prototype.destroy = function() {
                        var t = this;
                        if (this._initialized) {
                            var e = this._getTriggerEvents();
                            e.showEvents.forEach(function(e) {
                                t._triggerEl.removeEventListener(e, t._showHandler);
                            }), e.hideEvents.forEach(function(e) {
                                t._triggerEl.removeEventListener(e, t._hideHandler);
                            }), this._removeKeydownListener(), this._removeClickOutsideListener(), this._popperInstance && this._popperInstance.destroy(), this._initialized = !1;
                        }
                    }, t.prototype.removeInstance = function() {
                        s.default.removeInstance("Tooltip", this._instanceId);
                    }, t.prototype.destroyAndRemoveInstance = function() {
                        this.destroy(), this.removeInstance();
                    }, t.prototype._setupEventListeners = function() {
                        var t = this, e = this._getTriggerEvents();
                        this._showHandler = function() {
                            t.show();
                        }, this._hideHandler = function() {
                            t.hide();
                        }, e.showEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._showHandler);
                        }), e.hideEvents.forEach(function(e) {
                            t._triggerEl.addEventListener(e, t._hideHandler);
                        });
                    }, t.prototype._createPopperInstance = function() {
                        return (0, r.createPopper)(this._triggerEl, this._targetEl, {
                            placement: this._options.placement,
                            modifiers: [
                                {
                                    name: "offset",
                                    options: {
                                        offset: [
                                            0,
                                            8
                                        ]
                                    }
                                }
                            ]
                        });
                    }, t.prototype._getTriggerEvents = function() {
                        switch(this._options.triggerType){
                            case "hover":
                            default:
                                return {
                                    showEvents: [
                                        "mouseenter",
                                        "focus"
                                    ],
                                    hideEvents: [
                                        "mouseleave",
                                        "blur"
                                    ]
                                };
                            case "click":
                                return {
                                    showEvents: [
                                        "click",
                                        "focus"
                                    ],
                                    hideEvents: [
                                        "focusout",
                                        "blur"
                                    ]
                                };
                            case "none":
                                return {
                                    showEvents: [],
                                    hideEvents: []
                                };
                        }
                    }, t.prototype._setupKeydownListener = function() {
                        var t = this;
                        this._keydownEventListener = function(e) {
                            "Escape" === e.key && t.hide();
                        }, document.body.addEventListener("keydown", this._keydownEventListener, !0);
                    }, t.prototype._removeKeydownListener = function() {
                        document.body.removeEventListener("keydown", this._keydownEventListener, !0);
                    }, t.prototype._setupClickOutsideListener = function() {
                        var t = this;
                        this._clickOutsideEventListener = function(e) {
                            t._handleClickOutside(e, t._targetEl);
                        }, document.body.addEventListener("click", this._clickOutsideEventListener, !0);
                    }, t.prototype._removeClickOutsideListener = function() {
                        document.body.removeEventListener("click", this._clickOutsideEventListener, !0);
                    }, t.prototype._handleClickOutside = function(t, e) {
                        var i = t.target;
                        i === e || e.contains(i) || this._triggerEl.contains(i) || !this.isVisible() || this.hide();
                    }, t.prototype.isVisible = function() {
                        return this._visible;
                    }, t.prototype.toggle = function() {
                        this.isVisible() ? this.hide() : this.show();
                    }, t.prototype.show = function() {
                        this._targetEl.classList.remove("opacity-0", "invisible"), this._targetEl.classList.add("opacity-100", "visible"), this._popperInstance.setOptions(function(t) {
                            return n(n({}, t), {
                                modifiers: o(o([], t.modifiers, !0), [
                                    {
                                        name: "eventListeners",
                                        enabled: !0
                                    }
                                ], !1)
                            });
                        }), this._setupClickOutsideListener(), this._setupKeydownListener(), this._popperInstance.update(), this._visible = !0, this._options.onShow(this);
                    }, t.prototype.hide = function() {
                        this._targetEl.classList.remove("opacity-100", "visible"), this._targetEl.classList.add("opacity-0", "invisible"), this._popperInstance.setOptions(function(t) {
                            return n(n({}, t), {
                                modifiers: o(o([], t.modifiers, !0), [
                                    {
                                        name: "eventListeners",
                                        enabled: !1
                                    }
                                ], !1)
                            });
                        }), this._removeClickOutsideListener(), this._removeKeydownListener(), this._visible = !1, this._options.onHide(this);
                    }, t.prototype.updateOnShow = function(t) {
                        this._options.onShow = t;
                    }, t.prototype.updateOnHide = function(t) {
                        this._options.onHide = t;
                    }, t.prototype.updateOnToggle = function(t) {
                        this._options.onToggle = t;
                    }, t;
                }();
                function l() {
                    document.querySelectorAll("[data-tooltip-target]").forEach(function(t) {
                        var e = t.getAttribute("data-tooltip-target"), i = document.getElementById(e);
                        if (i) {
                            var n = t.getAttribute("data-tooltip-trigger"), o = t.getAttribute("data-tooltip-placement");
                            new d(i, t, {
                                placement: o || a.placement,
                                triggerType: n || a.triggerType
                            });
                        } else console.error('The tooltip element with id "'.concat(e, '" does not exist. Please check the data-tooltip-target attribute.'));
                    });
                }
                e.initTooltips = l, "undefined" != typeof window && (window.Tooltip = d, window.initTooltips = l), e.default = d;
            },
            947: function(t, e) {
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var i = function() {
                    function t(t, e) {
                        void 0 === e && (e = []), this._eventType = t, this._eventFunctions = e;
                    }
                    return t.prototype.init = function() {
                        var t = this;
                        this._eventFunctions.forEach(function(e) {
                            "undefined" != typeof window && window.addEventListener(t._eventType, e);
                        });
                    }, t;
                }();
                e.default = i;
            },
            423: function(t, e) {
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var i = new (function() {
                    function t() {
                        this._instances = {
                            Accordion: {},
                            Carousel: {},
                            Collapse: {},
                            Dial: {},
                            Dismiss: {},
                            Drawer: {},
                            Dropdown: {},
                            Modal: {},
                            Popover: {},
                            Tabs: {},
                            Tooltip: {},
                            InputCounter: {},
                            CopyClipboard: {}
                        };
                    }
                    return t.prototype.addInstance = function(t, e, i, n) {
                        if (void 0 === n && (n = !1), !this._instances[t]) return console.warn("Flowbite: Component ".concat(t, " does not exist.")), !1;
                        !this._instances[t][i] || n ? (n && this._instances[t][i] && this._instances[t][i].destroyAndRemoveInstance(), this._instances[t][i || this._generateRandomId()] = e) : console.warn("Flowbite: Instance with ID ".concat(i, " already exists."));
                    }, t.prototype.getAllInstances = function() {
                        return this._instances;
                    }, t.prototype.getInstances = function(t) {
                        return this._instances[t] ? this._instances[t] : (console.warn("Flowbite: Component ".concat(t, " does not exist.")), !1);
                    }, t.prototype.getInstance = function(t, e) {
                        if (this._componentAndInstanceCheck(t, e)) {
                            if (this._instances[t][e]) return this._instances[t][e];
                            console.warn("Flowbite: Instance with ID ".concat(e, " does not exist."));
                        }
                    }, t.prototype.destroyAndRemoveInstance = function(t, e) {
                        this._componentAndInstanceCheck(t, e) && (this.destroyInstanceObject(t, e), this.removeInstance(t, e));
                    }, t.prototype.removeInstance = function(t, e) {
                        this._componentAndInstanceCheck(t, e) && delete this._instances[t][e];
                    }, t.prototype.destroyInstanceObject = function(t, e) {
                        this._componentAndInstanceCheck(t, e) && this._instances[t][e].destroy();
                    }, t.prototype.instanceExists = function(t, e) {
                        return !!this._instances[t] && !!this._instances[t][e];
                    }, t.prototype._generateRandomId = function() {
                        return Math.random().toString(36).substr(2, 9);
                    }, t.prototype._componentAndInstanceCheck = function(t, e) {
                        return this._instances[t] ? !!this._instances[t][e] || (console.warn("Flowbite: Instance with ID ".concat(e, " does not exist.")), !1) : (console.warn("Flowbite: Component ".concat(t, " does not exist.")), !1);
                    }, t;
                }());
                e.default = i, "undefined" != typeof window && (window.FlowbiteInstances = i);
            }
        }, e = {};
        function i(n) {
            var o = e[n];
            if (void 0 !== o) return o.exports;
            var r = e[n] = {
                exports: {}
            };
            return t[n].call(r.exports, r, r.exports, i), r.exports;
        }
        i.d = function(t, e) {
            for(var n in e)i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, i.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return function() {
            var t = n;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), i(647);
            var e = i(902), o = i(33), r = i(922), s = i(556), a = i(791), c = i(340), d = i(316), l = i(16), u = i(903), p = i(247), h = i(671), f = i(656), v = i(673);
            i(311);
            var g = i(947);
            new g.default("load", [
                e.initAccordions,
                r.initCollapses,
                o.initCarousels,
                a.initDismisses,
                d.initDropdowns,
                l.initModals,
                c.initDrawers,
                p.initTabs,
                h.initTooltips,
                u.initPopovers,
                s.initDials,
                v.initCopyClipboards,
                f.initInputCounters
            ]).init(), t.default = {
                Accordion: e.default,
                Carousel: o.default,
                Collapse: r.default,
                Dial: s.default,
                Drawer: c.default,
                Dismiss: a.default,
                Dropdown: d.default,
                Modal: l.default,
                Popover: u.default,
                Tabs: p.default,
                Tooltip: h.default,
                InputCounter: f.default,
                CopyClipboard: v.default,
                Events: g.default
            };
        }(), n;
    }();
});

//# sourceMappingURL=index.946ca4df.js.map
